var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Observable } from 'rxjs/Observable';
import { catchError, filter, map, switchMap, takeWhile, withLatestFrom } from 'rxjs/operators';
import { of } from 'rxjs/observable/of';
import { CancelRefreshReportStatsAction, GET_REPORT_PROJECTS, GetReportProjectsFailureAction, GetReportProjectsSuccessAction, GetReportStatsFailureAction, GetReportStatsSuccessAction, REFRESH_REPORT_STATS, REFRESH_REPORT_STATS_REQUEST, RefreshReportStatsAction, RefreshReportStatsRequestAction, SET_REPORT_FILTERS, SetReportFiltersAction } from './reports.actions';
import { ProjectsService } from '../projects/projects.service';
import { StatsService } from '../stats/stats.service';
import { interval } from 'rxjs';
import { Store } from '@ngrx/store';
import { getReportFiltersSelector } from './reports.reducer';
import { LEAD_GENERATION_STATS_REPORTS_REFRESH_SECONDS } from '../../shared/constants';
import * as moment from 'moment';
var isStartOfToday = function (date) {
    var dateMoment = moment(date).startOf('day');
    var today = moment().startOf('day');
    return dateMoment.diff(today) === 0;
};
var ɵ0 = isStartOfToday;
var obtainNewDateRange = function (dateRange) {
    var dateFrom = dateRange.dateFrom;
    // when refreshing is running for long time the day can pass, but we want to show stats only from today
    var newDateFrom = isStartOfToday(dateFrom)
        ? dateFrom
        : moment()
            .startOf('day')
            .toDate();
    return __assign({}, dateRange, { dateFrom: newDateFrom, dateTo: new Date() });
};
var ɵ1 = obtainNewDateRange;
var ReportsEffects = /** @class */ (function () {
    function ReportsEffects(actions$, projectService, statsService, store) {
        var _this = this;
        this.actions$ = actions$;
        this.projectService = projectService;
        this.statsService = statsService;
        this.store = store;
        this.getFilterProjects = this.actions$.pipe(ofType(GET_REPORT_PROJECTS), switchMap(function () {
            return _this.projectService
                .allProjects()
                .pipe(map(function (response) { return new GetReportProjectsSuccessAction(response); }), catchError(function (error) { return of(new GetReportProjectsFailureAction(error)); }));
        }));
        this.getReportStats = this.actions$.pipe(ofType(SET_REPORT_FILTERS), map(function (action) { return action.payload; }), switchMap(function (filters) {
            return _this.statsService
                .getStats(filters)
                .pipe(map(function (response) { return new GetReportStatsSuccessAction(response); }), catchError(function (error) { return of(new GetReportStatsFailureAction(error)); }));
        }));
        this.startRefreshingReportStats = this.actions$.pipe(ofType(SET_REPORT_FILTERS), map(function (action) { return action.payload; }), withLatestFrom(this.store.select(getReportFiltersSelector)), filter(function (_a) {
            var updatedFilters = _a[0], store = _a[1];
            return !store.liveModeEnabled && isStartOfToday(updatedFilters.dateRange.dateFrom);
        }), map(function () { return new RefreshReportStatsRequestAction(LEAD_GENERATION_STATS_REPORTS_REFRESH_SECONDS); }));
        this.cancelRefreshingReportStats = this.actions$.pipe(ofType(SET_REPORT_FILTERS), map(function (action) { return action.payload; }), withLatestFrom(this.store.select(getReportFiltersSelector)), filter(function (_a) {
            var updatedFilters = _a[0], store = _a[1];
            return store.liveModeEnabled && !isStartOfToday(updatedFilters.dateRange.dateFrom);
        }), map(function () { return new CancelRefreshReportStatsAction(); }));
        this.refreshReportStatsRequest = this.actions$.pipe(ofType(REFRESH_REPORT_STATS_REQUEST), map(function (action) { return action.timeInSeconds; }), switchMap(function (seconds) {
            return interval(seconds * 1000).pipe(withLatestFrom(_this.store.select(getReportFiltersSelector)), takeWhile(function (_a) {
                var _ = _a[0], filters = _a[1];
                return filters.liveModeEnabled;
            }), map(function () { return new RefreshReportStatsAction(); }));
        }));
        this.refreshReportStats = this.actions$.pipe(ofType(REFRESH_REPORT_STATS), withLatestFrom(this.store.select(getReportFiltersSelector)), map(function (_a) {
            var _ = _a[0], filters = _a[1];
            var dateRange = obtainNewDateRange(filters.dateRange);
            return new SetReportFiltersAction(__assign({}, filters, { dateRange: dateRange }));
        }));
    }
    __decorate([
        Effect(),
        __metadata("design:type", Observable)
    ], ReportsEffects.prototype, "getFilterProjects", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Observable)
    ], ReportsEffects.prototype, "getReportStats", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Observable)
    ], ReportsEffects.prototype, "startRefreshingReportStats", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Observable)
    ], ReportsEffects.prototype, "cancelRefreshingReportStats", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Observable)
    ], ReportsEffects.prototype, "refreshReportStatsRequest", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Observable)
    ], ReportsEffects.prototype, "refreshReportStats", void 0);
    return ReportsEffects;
}());
export { ReportsEffects };
export { ɵ0, ɵ1 };
